import { gql } from '@apollo/client';

export const GET_TIPO_NOTIFICACIONES = gql`
    query GetTipoNotificaciones {
        notificacionesTipo {
            success
            error
            valorEsperado {
                idNotificacionTipo
                idNotificacionCategoria
                titulo
                descripcion
                condicionDisparador
                link
                habilitado
                obligatorio
                idMailTemplate
            }
        }
    }
`;